import { render, staticRenderFns } from "./question-completion.vue?vue&type=template&id=f8ba4680&scoped=true&"
import script from "./question-completion.vue?vue&type=script&lang=js&"
export * from "./question-completion.vue?vue&type=script&lang=js&"
import style0 from "./question-completion.vue?vue&type=style&index=0&id=f8ba4680&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8ba4680",
  null
  
)

export default component.exports